import PropTypes from "prop-types";
import { useState } from "react";
import { API } from "../../../services/api";
import { FieldLabel } from "../AdminCommon";
import { ROLES, ROLE_STYLES } from "../adminConstants";
import { userShape } from "../adminShapes";
import {
    btnBlackStyle,
    btnOutlineStyle,
    errorStyle,
    fieldStyle,
    inputStyle,
} from "../styles/adminDashboardStyles";

export function UserEditor({ user, roleOptions = ROLES, onSaved, onCancel }) {
    const [form, setForm] = useState({
        firstName: user.firstName ?? "",
        lastName: user.lastName ?? "",
        role: user.role ?? "PHARMACIEN",
    });
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    const handleSave = async (e) => {
        e.preventDefault();
        setSaving(true);
        setError(null);
        try {
            const { data } = await API.patch(`/admin/users/${user.id}`, {
                role: form.role,
                firstName: form.firstName || null,
                lastName: form.lastName || null,
            });
            onSaved(data);
        } catch (err) {
            setError(err.response?.data?.message ?? "Erreur lors de la sauvegarde.");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div style={{ background: "#f8fafc", borderTop: "1px solid #e5e7eb", padding: "16px 20px" }}>
            <form onSubmit={handleSave} style={{ display: "flex", gap: "14px", flexWrap: "wrap", alignItems: "flex-end" }}>
                <div style={{ ...fieldStyle, flex: "1 1 160px" }}>
                    <FieldLabel>Prénom</FieldLabel>
                    <input id={`admin-edit-user-${user.id}-first-name`} style={inputStyle} value={form.firstName} onChange={e => setForm(f => ({ ...f, firstName: e.target.value }))} />
                </div>
                <div style={{ ...fieldStyle, flex: "1 1 160px" }}>
                    <FieldLabel>Nom</FieldLabel>
                    <input id={`admin-edit-user-${user.id}-last-name`} style={inputStyle} value={form.lastName} onChange={e => setForm(f => ({ ...f, lastName: e.target.value }))} />
                </div>
                <div style={{ ...fieldStyle, flex: "0 0 160px" }}>
                    <FieldLabel>Rôle</FieldLabel>
                    <select id={`admin-edit-user-${user.id}-role`} style={inputStyle} value={form.role} onChange={e => setForm(f => ({ ...f, role: e.target.value }))}>
                        {roleOptions.map(r => <option key={r} value={r}>{ROLE_STYLES[r]?.label ?? r}</option>)}
                    </select>
                </div>
                <button type="submit" disabled={saving} style={btnBlackStyle}>
                    {saving ? "Sauvegarde..." : "Enregistrer"}
                </button>
                <button type="button" onClick={onCancel} style={btnOutlineStyle}>
                    Annuler
                </button>
            </form>
            {error && <p style={errorStyle}>{error}</p>}
        </div>
    );
}

UserEditor.propTypes = {
    user: userShape.isRequired,
    onSaved: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};
